import { TDealsFilters, TDealsResponse } from "@/models/deals.model";
import {
  TCreatePipelineViewPayload,
  TCreateViewDealPayload,
  TPipelineView,
  TPipelineViewShareOptions,
  TPipelineViewShares,
  TPipelineViewStage,
  TPipelineViewStagePayload,
  TUpdatePipelineViewStagePayload,
  TViewDeal,
} from "@/models/pipeline-views.model";
import axios from "@utils/axios-instance";

const getAll = async (): Promise<TPipelineView[]> => {
  const response = await axios.get(`/pipeline-view`);
  return response.data;
};

const getById = async (viewId: number): Promise<TPipelineView> => {
  const response = await axios.get(`/pipeline-view/${viewId}`);
  return response.data;
};

const create = async (data: TCreatePipelineViewPayload): Promise<TPipelineView> => {
  const response = await axios.post(`/pipeline-view`, data);
  return response.data;
};

const rename = async (viewId: number, name: string): Promise<TPipelineView> => {
  const response = await axios.patch(`/pipeline-view/${viewId}`, { name });
  return response.data;
};

const remove = async (viewId: number): Promise<void> => {
  await axios.delete(`/pipeline-view/${viewId}`);
};

const getShareOptions = async (): Promise<TPipelineViewShareOptions> => {
  const response = await axios.get(`/pipeline-view/share-options`);
  return response.data;
};

const share = async (viewId: number, data: TPipelineViewShares): Promise<TPipelineView> => {
  const response = await axios.put(`/pipeline-view/${viewId}/share`, data);
  return response.data;
};

const createStage = async (viewId: number, data: TPipelineViewStagePayload): Promise<TPipelineViewStage> => {
  const response = await axios.post(`/pipeline-view/${viewId}/stage`, data);
  return response.data;
};

const updateStage = async (stageId: number, data: TUpdatePipelineViewStagePayload): Promise<TPipelineViewStage> => {
  const response = await axios.patch(`/pipeline-view/stage/${stageId}`, data);
  return response.data;
};

const deleteStage = async (stageId: number): Promise<void> => {
  await axios.delete(`/pipeline-view/stage/${stageId}`);
};

/** One column of the view board. Same filters as GET /deal except pipelineId, status and catalog. */
const getDeals = async (
  viewId: number,
  viewStageId: number,
  filters: TDealsFilters
): Promise<TDealsResponse & { data: TViewDeal[] }> => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { pipelineId, status, ...rest } = filters;
  const params = Object.fromEntries(
    Object.entries({ ...rest, viewStageId }).filter(([, val]) => Boolean(val))
  );
  const queryString = new URLSearchParams(params as Record<string, string>).toString();
  const response = await axios.get(`/pipeline-view/${viewId}/deal?${queryString}`);
  return response.data;
};

const moveDeal = async (viewId: number, dealId: number, viewStageId: number): Promise<TViewDeal> => {
  const response = await axios.patch(`/pipeline-view/${viewId}/deal/${dealId}`, { viewStageId });
  return response.data;
};

const createDeal = async (viewId: number, data: TCreateViewDealPayload): Promise<TViewDeal> => {
  const response = await axios.post(`/pipeline-view/${viewId}/deal`, data);
  return response.data;
};

export default {
  getAll,
  getById,
  create,
  rename,
  remove,
  getShareOptions,
  share,
  createStage,
  updateStage,
  deleteStage,
  getDeals,
  moveDeal,
  createDeal,
};
